import { HttpClient } from "../api/httpclient.service";

export interface SendNotificationPayload {
  recipient_id: number;
  notification_type?: "encouragement" | "review" | "exercise_review" | "system";
  title?: string;
  body: string;
  teacher_id?: number;
  metadata?: Record<string, any>;
}

export interface NotificationItem {
  id: number;
  sender_id: number;
  sender_name: string;
  sender_initials: string;
  recipient_id: number;
  notification_type: string;
  title?: string | null;
  body: string;
  metadata: Record<string, any>;
  is_read: boolean;
  read_at?: string | null;
  created_at: string;
  exercise_name?: string | null;
  deep_link?: string | null;
}

export interface NotificationListResponse {
  notifications: NotificationItem[];
  total_count: number;
  unread_count: number;
}

export interface UnreadCountResponse {
  unread_count: number;
}

export type TeacherNotificationItem = NotificationItem;

export class NotificationService extends HttpClient {
  public async getUnreadCount(): Promise<UnreadCountResponse> {
    return await this.get<UnreadCountResponse>("/notifications/unread-count");
  }

  public async getNotifications(page = 1, limit = 20): Promise<NotificationListResponse> {
    return await this.get<NotificationListResponse>(`/notifications?page=${page}&limit=${limit}`);
  }

  public async listNotifications(page = 1, limit = 20): Promise<NotificationListResponse> {
    return await this.getNotifications(page, limit);
  }

  public async getNotificationById(notificationId: number | string): Promise<TeacherNotificationItem> {
    return await this.get<TeacherNotificationItem>(`/notifications/${notificationId}`);
  }

  public async sendNotification(payload: SendNotificationPayload): Promise<{ notification_id: number }> {
    return await this.post<{ notification_id: number }>("/notifications", payload);
  }

  public async markAsRead(notificationId: number | string): Promise<void> {
    await this.patch(`/notifications/${notificationId}/read`, {});
  }

  public async markAllAsRead(): Promise<void> {
    await this.patch("/notifications/read-all", {});
  }

  public async deleteNotification(notificationId: number | string): Promise<void> {
    await this.delete(`/notifications/${notificationId}`);
  }
}

export const notificationService = new NotificationService();
